module.exports = __webpack_public_path__ + "static/media/arrowHeader.4beba3c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrowHeader.svg
// module id = 150
// module chunks = 0